import { createSelector } from '@reduxjs/toolkit';
import selectTrayInstances from './selectTrayInstances';

export default createSelector(selectTrayInstances, (instances) =>
  instances.filter(({ enabled, socialiveAvailable }) => enabled && socialiveAvailable)
);
